<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/jxky/home">教学科研</router-link> >
      <router-link to="/jxky/yanjiusheng">研究生教育</router-link> >
      {{ subname }}
    </div>
    <div class="container-width x-article">
      <div class="title">{{ subname }}</div>
      <div style="padding: 0 50px; box-sizing: border-box">
        <a class="h-name">博士导师</a>
        <ul>
          <li
            v-for="(item, index) in boshiData"
            :key="index"
            @click="goDaoshi(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div style="padding: 0 50px; box-sizing: border-box">
        <a class="h-name">硕士导师</a>
        <ul>
          <li
            v-for="(item, index) in shuoshiData"
            :key="index"
            @click="goDaoshi(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
 
</template>
<script>
import service from "../../service/jxky";
import serviceIndex from "../../service/index";
import BANNER from "../../components/banner/jxky";
import { jxkyNavDic } from "../../const/navigationData";
export default {
  name: "YANJIUSHENGXUEKE",
  data() {
    return {
      navigationData: jxkyNavDic,
      currentPath: "/jxky/yanjiusheng",
      id: 0,
      subname: "",
      boshiData: [],
      shuoshiData: [],
      sjkdData: [],
      mtksjData: [],
      ylzhData: [],
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.id = this.$route.query.id || 0;
    this.subname = this.$route.query.xueke || "";
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let parmes = {
        subjectId: this.id,
        pageIndex: 1,
        pageSize: 500,
      };
      service.getwzGraduateList(parmes, (res) => {
        let boshiData = [];
        let shuoshiData = [];
        if (res.content.length) {
          res.content.map((item) => {
            if (item.type == "博士导师") {
              boshiData.push(item);
            } else {
              shuoshiData.push(item);
            }
            this.boshiData = boshiData;
            this.shuoshiData = shuoshiData;
          });
        }
      });
      //盛京看点
      // let parmes2 = {
      //   pageIndex: 1,
      //   pageSize: 6,
      //   isshow: "1",
      //   issuggest: "1",
      // };
      // serviceIndex.getWatchList(parmes2, (res) => {
      //   if (res.content.length) {
      //     res.content.map((item) => {
      //       item.title = item.title.substr(0, 16) + "...";
      //     });
      //   }
      //   this.sjkdData = res.content || [];
      // });
      // serviceIndex.getwzMediaViewsjList(parmes2, (res) => {
      //   if (res.content.length) {
      //     res.content.map((item) => {
      //       item.title = item.title.substr(0, 16) + "...";
      //     });
      //   }
      //   this.mtksjData = res.content || [];
      // });
      // serviceIndex.getwzMedicalAffairsList(parmes2, (res) => {
      //   if (res.content.length) {
      //     res.content.map((item) => {
      //       item.title = item.title.substr(0, 16) + "...";
      //     });
      //   }
      //   this.ylzhData = res.content || [];
      // });
    },
    gokdArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let articleId = e.id;
        const { href } = this.$router.resolve({
          path: `/sjkd/article/${articleId}`,
        });
        window.open(href, "_self");
      }
    },

    goylzhArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let articleId = e.id;
        const { href } = this.$router.resolve({
          path: `/sjkd/ylzh/article/${articleId}`,
        });
        window.open(href, "_blank");
      }
    },
    gomtksjArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let articleId = e.id;
        const { href } = this.$router.resolve({
          path: `/lxwm/mtksj/article/${articleId}`,
        });
        window.open(href, "_blank");
      }
    },

    goDaoshi(item) {
      let articleId = item.id || 0;
      let name = this.subname || "";
      const { href } = this.$router.resolve({
        path: `/jxky/yanjiusheng/daoshi`,
        query: {
          id: `${articleId}`,
          xueke: `${name}`,
        },
      });
      window.open(href, "_blank");
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style scoped lang="scss">
.h-name {
  width: 100%;
  display: block;
  height: 59px;
  line-height: 59px;
  text-align: center;
  overflow: hidden;
  background: url(../../assets/title_bj1.png) no-repeat center center;
  font-size: 1.4rem;
  color: #000;
  font-weight: bold;
  margin-top: 50px;
  background-size: 100% 100%;
}
ul {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  row-gap: 30px;
  column-gap: 30px;
  margin-top: 50px;
  padding-bottom: 50px;
  li {
    height: 42px;
    line-height: 40px;
    text-align: center;
    overflow: hidden;
    border: 1px solid #00479d;
    font-size: 1.1rem;
    color: #00479d;
    font-weight: 600;
    transition: all 0.4s;
  }
  li:hover {
    background: #00479d;
    color: #fff;
    cursor: pointer;
  }
}
.x-article {
  -webkit-transition: all 0.5s ease 0s;
  -moz-transition: all 0.5s ease 0s;
  transition: all 0.5s ease 0s;
  box-shadow: 4px 4px #ececec;
  margin-bottom: 50px;
  border: 1px solid #ebebeb;
  border-top: none;
  box-sizing: border-box;

  .title {
    padding-top: 30px;
    padding-bottom: 30px;
    font-weight: bold;
    text-align: center;
    border-bottom: 1px solid #ebebeb;
    font-size: 1.8rem;
    color: #323232;
  }
}
@media only screen and (max-width: 728px) {
  ul {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
  .h-name {
    font-size: 1.2rem;
    background-size: 175% 100%;
  }
}
@media only screen and (max-width: 420px) {
  ul {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }
  .h-name {
    font-size: 1.2rem;
    background-size: 175% 100%;
  }
}
</style>

